<script>
import { mapActions, mapState } from 'vuex';
import TwConfirmDialog from '../components/TwConfirmDialog';
import XmlChannelStatusCards from '../components/xmlChannelStatus/XmlChannelStatusCards';
import XmlChannelStatusControl from '../components/xmlChannelStatus/XmlChannelStatusControl';
import XmlChannelJobList from '../components/xmlChannelStatus/XmlChannelJobList';
import TwOverlay from '../components/TwOverlay';

export default {
  name: 'XmlChannelStatus',
  components: {
    TwConfirmDialog,
    TwOverlay,
    XmlChannelStatusCards,
    XmlChannelStatusControl,
    XmlChannelJobList,
  },
  data() {
    return {
      dialog: 0,
      xmlChannel: undefined,
    };
  },
  methods: {
    ...mapActions({
      setBreadcrumbs: 'nav/setBreadcrumbs',
      activateLatestJob: 'xmlChannelStatus/activateLatestJob',
      getXmlChannels: 'xmlChannelStatus/getXmlChannels',
      openJobListDialog: 'xmlChannelStatus/openJobList',
    }),
    openJobList(xmlChannel) {
      this.dialog += 1;
      this.openJobListDialog(xmlChannel);
    },
    confirmActivateLatestJob(xmlChannel) {
      this.xmlChannel = xmlChannel;
      this.$refs.confirmActivateLatestJob.open();
    },
    cancelActivateLatestJob() {
      this.xmlChannel = undefined;
    },
  },
  computed: {
    ...mapState({
      xmlChannels: state => state.xmlChannelStatus.xmlChannels,
    }),
  },
  created() {
    this.setBreadcrumbs({
      breadcrumbs: [
        { text: this.$t('menu.xmlChannelStatus.pages.xmlChannelStatus'), to: '', disabled: true },
      ],
      title: this.$t('menu.xmlChannelStatus.title'),
    });
  },
  mounted() {
    if (this.xmlChannels.items.length === 0 && !this.xmlChannels.items.loading) {
      this.getXmlChannels();
    }
  },
};
</script>

<template>
  <v-flex xs-12 channel-status>
    <v-progress-circular
      class="channel-status__loading"
      v-if="xmlChannels.loading"
      :active="xmlChannels.loading"
      indeterminate
    />
    <tw-overlay :visible="xmlChannels.loading"></tw-overlay>
    <tw-confirm-dialog
      @confirm="activateLatestJob(xmlChannel)"
      @cancel="cancelActivateLatestJob"
      title="Are you sure?"
      description="This will activate the latest job - are you sure?"
      ref="confirmActivateLatestJob"
    />
    <xml-channel-status-control/>
    <xml-channel-status-cards
      @activate-latest-job="confirmActivateLatestJob"
      @open-job-list="openJobList"
      @refresh="getXmlChannels"
    />
    <xml-channel-job-list :show="dialog"/>
  </v-flex>
</template>

<style lang="scss">
  .channel-status {
    position: relative;
    min-height: 300px;

    &__loading {
      position: absolute;
      top: 150px;
      left: 50%;
      z-index: 20;
      transform: translateX(-50%);
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/XmlChannelStatus.vue